import { Injectable } from "@angular/core";
import {
  Http,
  Response,
  RequestOptions,
  ResponseContentType,
} from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/first";

import { environment } from "../../environments/environment";

import { Configurations } from "../core/configurations";
import { AuthService } from "./auth.service";
import { SliderModel } from "../models/dashboard/slider.model";
import { BloccoModel } from "../models/dashboard/blocco.model";
import { BloccoAuthModel } from "../models/dashboard/BloccoAuth.model";
import { BloccoSliderModel } from "../models/dashboard/bloccoSlider.model";
import { SaveBloccoModel } from "../models/dashboard/saveBlocco.model";
import { DeleteBloccoModel } from "../models/dashboard/deleteBlocco.model";
import { BloccoTipoModel } from "../models/dashboard/bloccoTipo.model";
import { ExternalSourceDriverModel } from "../models/dashboard/externalSourceDriver.model";
import { BloccoBusinessLineModel } from "../components/utils/item-manager/business-line-blocco-manager/business-line-blocco-manager.component";

@Injectable()
export class DashboardService {
  APIDashboard = this.configuration.apiBaseUrlDashboard;
  APITipiAssegni = this.configuration.apiBaseUrlTipiAssegni;
  sliders = "sliders";
  blocchi = "blocchi";
  routes = "bloccorouteanagrafica";
  responseTypes = "bloccohttpresponsetipo";
  authManItems = "authmanitemslider";
  tipi = "blocchiTipoConq";
  bloccoTipo = "bloccotipo";
  bloccoFile = "bloccofile";

  blocchiToDOWNLOAD = "blocchitodownload/";
  createbloccotodownload = "CreateBloccoToDOWNLOAD";
  deletebloccotodownload = "DeleteBloccoToDOWNLOAD";

  blocchiToSlider = "blocchitosliders";
  createBlocchiToSlider = "CreateBloccoToSlider";
  updateBlocchiToSlider = "UpdateBloccoToSlider";
  deleteBloccoToSlider = "DeleteBloccoToSlider";

  blocchiToAuth = "blocchitoauthmanitems";
  createBlocchiToAuth = "CreateBloccoToAuthManItems";
  deleteBloccoToAuth = "DeleteBloccoToAuthManItems";

  blocchiMetadata = "blocchiiframeuserdefined/";
  addmetadata = "CreateBlocchiIFRAMEUserDefined";
  editmetadata = "UpdateBlocchiIFRAMEUserDefined";
  deletemetadata = "DeleteBlocchiIFRAMEUserDefined";

  blocchiLinkMetadata = "blocchilinkuserdefined/";
  addLinkmetadata = "CreateBlocchiLINKUserDefined";
  editLinkmetadata = "UpdateBlocchiLINKUserDefined";
  deleteLinkmetadata = "DeleteBlocchiLINKUserDefined";

  blocchiHttpMetadata = "blocchihttpdatauserdefined/";
  addHttpmetadata = "CreateBlocchiHTTPDataUserDefined";
  editHttpmetadata = "UpdateBlocchiHTTPDataUserDefined";
  deleteHttpmetadata = "DeleteBlocchiHTTPDataUserDefined";

  externalSourceDriver = "bloccodownloadexternalsourcedriver";
  externalSourceDriverTipo = "blocchidownloadexternalsourcedrivertipo";

  taxonomy = "bloccodownloadexternalsourcetaxonomy/";
  itemTaxonomy = "bloccodownloadexternalsourceitemtaxonomy/";
  taxonomyTipo = "bloccodownloadexternalsourceitemtaxonomytipo/";
  externalsourcedownload = "bloccodownloadexternalsourcedownload/";

  businesslines = "businesslines";
  blocchiBusinessLine = "blocchitobusinesslines";
  createBlocchiToBusinessLine = "CreateBloccoToBusinessLine";
  editBlocchiToBusinessLine = "UpdateBloccoToBusinessLine";
  deleteBloccoToBusinessLine = "DeleteBloccoToBusinessLine";

  apiBaseUrlStampe = this.configuration.apiBaseUrlStampe;

  constructor(
    private http: Http,
    private configuration: Configurations,
    private authenticationService: AuthService
  ) {}

  getBasePath() {
    return this.APIDashboard;
  }

  getSliders(): Observable<SliderModel[]> {
    let url = this.APIDashboard + this.sliders;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as SliderModel[])
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }
  getSlider(
    token: string,
    fromAdminPage: boolean,
    role?: number
  ): Observable<SliderModel> {
    let url = `${this.APIDashboard}${this.sliders}/${token}?fromAdminPage=${fromAdminPage}`;
    if (role) {
      url = `${url}&nomeAuthManItem=${role}`;
    }
    return this.http
      .get(url)
      .map((r: Response) => r.json() as SliderModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  updateSlider(slider: SliderModel): Observable<SliderModel> {
    let url = `${this.APIDashboard}${this.sliders}/UpdateSlider`;
    return this.http
      .put(url, slider)
      .map((r: Response) => r.json() as SliderModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getBloccoTipi(): Observable<BloccoTipoModel[]> {
    let url = this.APIDashboard + this.bloccoTipo;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as BloccoTipoModel[])
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getAuthManItems(): Observable<any[]> {
    let url = `${this.APIDashboard}${this.authManItems}?type=0`;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as string[])
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getBloccoSlider(token: string): Observable<BloccoModel> {
    let url = `${this.APIDashboard}${this.blocchi}/${token}`;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getAllBlocchi(filters: string): Observable<Array<BloccoModel>> {
    let url = `${this.APIDashboard}${this.blocchi}/ricerca?${filters}`;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as Array<BloccoModel>)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  //addBlocco
  getAddUrl(codiceBloccoTipo) {
    switch (codiceBloccoTipo) {
      case "HTML":
        return "CreateHTML";
      case "IFRAME":
        return "CreateIFRAME";
      case "LINK":
        return "CreateLINK";
      case "IMG":
        return "CreateIMG";
      case "DOWNLOAD":
        return "CreateDownload";
      case "HTTP_Data":
        return "CreateHTTPData";
      case "DownloadExternalSource":
        return "CreateDownloadExternalSource";
      default:
        return "CreateGeneric";
    }
  }
  //deleteBlocco
  getDeleteUrl(tipoBlocco) {
    switch (tipoBlocco) {
      case "HTML":
        return "DeleteHTML";
      case "IFRAME":
        return "DeleteIFRAME";
      case "LINK":
        return "DeleteLINK";
      case "IMG":
        return "DeleteIMG";
      case "DOWNLOAD":
        return "DeleteDownload";
      case "HTTP_Data":
        return "DeleteHTTPData";
      case "DownloadExternalSource":
        return "DeleteDownloadExternalSource";
      default:
        return "DeleteGeneric";
    }
  }
  //updateBlocco
  getUpdateUrl(codiceBloccoTipo) {
    switch (codiceBloccoTipo) {
      case "HTML":
        return "UpdateHTML";
      case "IFRAME":
        return "UpdateIFRAME";
      case "LINK":
        return "UpdateLINK";
      case "IMG":
        return "UpdateIMG";
      case "DOWNLOAD":
        return "UpdateDownload";
      case "HTTP_Data":
        return "UpdateHTTPData";
      case "DownloadExternalSource":
        return "UpdateDownloadExternalSource";
      default:
        return "UpdateGeneric";
    }
  }

  addBlocco(blocco: SaveBloccoModel): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchi}/${this.getAddUrl(
      blocco.codiceBloccoTipo
    )}`;
    return this.http
      .post(url, blocco)
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }
  updateBlocco(blocco: SaveBloccoModel): Observable<any> {
    let tipo = blocco.tipoBlocco ? blocco.tipoBlocco : blocco.codiceBloccoTipo;
    let url = `${this.APIDashboard}${this.blocchi}/${this.getUpdateUrl(tipo)}`;
    return this.http
      .put(url, blocco)
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }
  deleteBlocco(blocco): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchi}/${this.getDeleteUrl(
      blocco.codiceBloccoTipo
    )}`;
    let body: {
      id: number;
      token: string;
      codiceBloccoTipo?: string;
    } = {
      id: blocco.id,
      token: blocco.token,
    };
    if (this.getDeleteUrl(blocco.codiceBloccoTipo).includes("Generic")) {
      body = {
        ...body,
        codiceBloccoTipo: blocco.codiceBloccoTipo,
      };
    }
    return this.http
      .delete(
        url,
        new RequestOptions({
          body: { ...body },
        })
      )
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }
  //addBloccoToAuth
  addBloccoToAuth(bloccoAuth: BloccoAuthModel): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiToAuth}/${this.createBlocchiToAuth}`;
    return this.http
      .post(url, bloccoAuth)
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }
  //deleteBloccoSlider
  deleteBloccoAuth(id: number): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiToAuth}/${this.deleteBloccoToAuth}`;
    return this.http
      .delete(
        url,
        new RequestOptions({
          body: { id: id },
        })
      )
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  //addBloccoToSlider
  addBloccoToSlider(bloccoSlider: BloccoSliderModel): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiToSlider}/${this.createBlocchiToSlider}`;
    return this.http
      .post(url, bloccoSlider)
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  //editBloccoToSlider
  editBloccoToSlider(bloccoSlider: BloccoSliderModel): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiToSlider}/${this.updateBlocchiToSlider}`;
    return this.http
      .put(url, bloccoSlider)
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  //deleteBloccoSlider
  deleteBloccoSlider(id: number): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiToSlider}/${this.deleteBloccoToSlider}`;
    return this.http
      .delete(
        url,
        new RequestOptions({
          body: { id: id },
        })
      )
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  uploadFile(model: any): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("TokenProprietario", model.token);
    formData.append("idAllegatoTipo", model.id);
    formData.append("file", model.file);

    let url = `${this.APIDashboard}${this.bloccoFile}/Upload`;
    return this.http
      .post(url, formData)
      .map((r: Response) => r.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  downloadFile(token: string): Observable<File> {
    let url = `${this.APIDashboard}${this.bloccoFile}/Download/${token}`;
    return this.http
      .get(url, { responseType: ResponseContentType.Blob })
      .map((res: Response) => res.blob())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  createBloccoToDOWNLOAD(body): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiToDOWNLOAD}${this.createbloccotodownload}`;
    return this.http
      .post(url, body)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  deleteBloccoToDOWNLOAD(body): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiToDOWNLOAD}${this.deletebloccotodownload}`;
    return this.http
      .delete(url, new RequestOptions({ body }))
      .map((res: Response) => res.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  //addMetadataBlocco
  getMetadataAddUrl(codiceBloccoTipo) {
    switch (codiceBloccoTipo) {
      case "IFRAME":
        return `${this.blocchiMetadata}${this.addmetadata}`;
      case "HTTP_Data":
        return `${this.blocchiHttpMetadata}${this.addHttpmetadata}`;
      case "LINK":
        return `${this.blocchiLinkMetadata}${this.addLinkmetadata}`;
      default:
        return "CreateGenericMetadata";
    }
  }
  //updateMetadataBlocco
  getMetadataUpdateUrl(codiceBloccoTipo) {
    switch (codiceBloccoTipo) {
      case "IFRAME":
        return `${this.blocchiMetadata}${this.editmetadata}`;
      case "HTTP_Data":
        return `${this.blocchiHttpMetadata}${this.editHttpmetadata}`;
      case "LINK":
        return `${this.blocchiLinkMetadata}${this.editLinkmetadata}`;
      default:
        return "UpdateGenericMetadata";
    }
  }
  //deleteMetadataBlocco
  getMetadataDeleteUrl(tipoBlocco) {
    switch (tipoBlocco) {
      case "IFRAME":
        return `${this.blocchiMetadata}${this.deletemetadata}`;
      case "HTTP_Data":
        return `${this.blocchiHttpMetadata}${this.deleteHttpmetadata}`;
      case "LINK":
        return `${this.blocchiLinkMetadata}${this.deleteLinkmetadata}`;
      default:
        return "DeleteGenericMetadata";
    }
  }

  addMetadata(body, codiceBloccoTipo) {
    let url = `${this.APIDashboard}${this.getMetadataAddUrl(codiceBloccoTipo)}`;
    return this.http
      .post(url, body)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }
  editMetadata(body, codiceBloccoTipo) {
    let url = `${this.APIDashboard}${this.getMetadataUpdateUrl(
      codiceBloccoTipo
    )}`;
    return this.http
      .put(url, body)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }
  deleteMetadata(body, codiceBloccoTipo) {
    let url = `${this.APIDashboard}${this.getMetadataDeleteUrl(
      codiceBloccoTipo
    )}`;
    return this.http
      .delete(url, new RequestOptions({ body }))
      .map((res: Response) => res.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getIframeData(url) {
    return this.http
      .post(url, {})
      .map((res: Response) => res.json())
      .catch((r: any) => {
        return Observable.throw(r);
      });
  }

  getHttpData(url) {
    return this.http
      .post(url, {})
      .map((res: Response) => res.json())
      .catch((r: any) => {
        return Observable.throw(r);
      });
  }

  postHttpData(url, body) {
    return this.http
      .post(url, body)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        return Observable.throw(r);
      });
  }

  getAnagraficaRoutes(): Observable<any[]> {
    let url = this.APIDashboard + this.routes;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as any[])
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getResponseTypes(): Observable<any[]> {
    let url = this.APIDashboard + this.responseTypes;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as any[])
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getBlocchiDownloadExternalSourceDriver(): Observable<any[]> {
    let url = this.APIDashboard + this.externalSourceDriver;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as any[])
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  createBloccoDownloadExternalSourceDriver(body: ExternalSourceDriverModel) {
    let url = `${this.APIDashboard}${this.externalSourceDriver}/CreateBloccoDownloadExternalSourceDriver`;
    return this.http
      .post(url, body)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getBlocchiDownloadExternalSourceDriverTipo(): Observable<any[]> {
    let url = this.APIDashboard + this.externalSourceDriverTipo;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as any[])
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getTaxonomy(id: number) {
    let url = `${this.APIDashboard}${this.taxonomy}/${id}`;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as string)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  saveTaxonomy(body) {
    let url = `${this.APIDashboard}${this.taxonomy}CreateBloccoDownloadExternalSourceTaxonomyAsync`;
    return this.http
      .post(url, body)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  updateTaxonomy(body) {
    let url = `${this.APIDashboard}${this.taxonomy}UpdateBloccoDownloadExternalSourceTaxonomyAsync`;
    return this.http
      .post(url, body)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getItems(body) {
    let url = `${this.APIDashboard}${this.itemTaxonomy}`;
    return this.http
      .post(url, body)
      .map((r: Response) => r.json() as string)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getTaxonomyTipo() {
    let url = `${this.APIDashboard}${this.taxonomyTipo}`;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as string)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  getExternalSourceItems(url) {
    return this.http
      .get(url)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        return Observable.throw(r);
      });
  }

  postExternalSourceItems(url, body) {
    return this.http
      .post(url, body)
      .map((res: Response) => res.json())
      .catch((r: any) => {
        return Observable.throw(r);
      });
  }
  downloadExternalSourceFile(id) {
    let url = `${this.APIDashboard}${this.externalsourcedownload}download?idBloccoDownloadExternalSourceItem=${id}`;
    return this.http
      .get(url, { responseType: ResponseContentType.Blob })
      .map((res: Response) => res.blob())
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  downloadExternalSourceFileDriver(url) {
    return this.http
      .get(url, { responseType: ResponseContentType.Blob })
      .map((res: Response) => res.blob())
      .catch((r: any) => {
        return Observable.throw(r);
      });
  }

  getAllBusinessLines(): Observable<any[]> { //BusinessLine
    let url = this.APIDashboard + this.businesslines;
    return this.http
      .get(url)
      .map((r: Response) => r.json() as SliderModel[])
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

  addBloccoToBusinessLine(bloccoAuth: BloccoBusinessLineModel): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiBusinessLine}/${this.createBlocchiToBusinessLine}`;
    return this.http
      .post(url, bloccoAuth)
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }
  //deleteBloccoSlider
  deleteBloccoBusinessLine(id: number): Observable<any> {
    let url = `${this.APIDashboard}${this.blocchiBusinessLine}/${this.deleteBloccoToBusinessLine}`;
    return this.http
      .delete(
        url,
        new RequestOptions({
          body: { id: id },
        })
      )
      .map((r: Response) => r.json() as BloccoModel)
      .catch((r: any) => {
        if (r.status === 401) {
          this.authenticationService
            .logoutIfSessionExpired()
            .subscribe((res: any) => {});
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }



}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/dashboard.service.ts